import { flexRender } from "@tanstack/react-table";
import styles from "./recent-properties.module.scss";
import { scrollToTop } from "../../utils/const";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import Pagination from "../common/pagination";
import { useEffect, useRef, useState } from "react";
import NoDataFoundC from "../common/no-data-found";
import ReactTableSkeleton from "../../skeleton/dashboard/ReactTable";
import { NavigatePropertyDetail } from "../investor/amplitude";
const DashboardListing = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageParams = Number(queryParams.get("page")) || 1;
  const limitParams = Number(queryParams.get("limit")) || 10;

  const [first, setFirst] = useState<any>((pageParams - 1) * limitParams);
  const [rows, setRows] = useState<any>(limitParams);
  const listingWrapRef = useRef<any>(null);

  const onPageChange: any = async (e: { first: number; rows: number }) => {
    const newPage = e.first / e.rows + 1;

    setFirst(e.first);
    setRows(e.rows);

    navigate({
      search: `?${createSearchParams({
        panel: String(queryParams.get("panel") || 0),
        page: String(newPage),
        limit: String(e.rows)
      })}`
    });
  };

  useEffect(() => {
    const pageFromURL = Number(queryParams.get("page")) || 1;
    const rowsFromURL = Number(queryParams.get("limit")) || 10;
    setFirst((pageFromURL - 1) * rowsFromURL);
    setRows(rowsFromURL);
  }, [location.search]);

  useEffect(() => {
    const pageFromURL = Number(queryParams.get("page")) || 1;
    const rowsFromURL = Number(queryParams.get("limit")) || 10;
    setFirst((pageFromURL - 1) * rowsFromURL);
    setRows(rowsFromURL);
  }, [location.search]);

  useEffect(() => {
    // Wait until the data is loaded and `columnWrap` is rendered
    if (props.recentPropertyData?.length > 0 && listingWrapRef.current) {
      const handleScroll = () => {
        if (listingWrapRef.current) {
          sessionStorage.setItem(
            "scrollPosition",
            listingWrapRef.current.scrollTop.toString()
          );
        }
      };

      const listingWrap = listingWrapRef.current;
      listingWrap?.addEventListener("scroll", handleScroll);

      // Clean up scroll listener
      return () => {
        listingWrap?.removeEventListener("scroll", handleScroll);
      };
    }
  }, [props.recentPropertyData]);

  useEffect(() => {
    // Restore scroll position after data is loaded and ref is assigned
    if (props.recentPropertyData?.length > 0 && listingWrapRef.current) {
      const savedScrollPosition = sessionStorage.getItem("scrollPosition");
      if (savedScrollPosition && listingWrapRef.current) {
        listingWrapRef.current.scrollTo(0, parseInt(savedScrollPosition, 10));
      }
    }
  }, [props.recentPropertyData]);

  return (
    <>
      {props.isLoading ? (
        <>
          <ReactTableSkeleton yourOffersTab={false} />
        </>
      ) : (
        <>
          {props?.recentPropertyData?.length === 0 ? (
            // <div className={styles.noDataContainer}>
            <NoDataFoundC panelIndex={props.panelIndex || 0} />
          ) : (
            // </div>
            <div
              className={styles.propertyTable}
              style={{ opacity: props.isPlaceholderData ? 0.5 : 1 }}
            >
              <div className={styles.propertyColumn}>
                {props.recentPropertyData?.length > 0 && (
                  <div className={styles.columnWrap} ref={listingWrapRef}>
                    <table id="recentPropertyColumns">
                      <thead id="header">
                        {props?.table
                          ?.getHeaderGroups()
                          ?.map((headerGroup: any) => (
                            <tr key={headerGroup.id}>
                              {headerGroup?.headers?.map((header: any) => (
                                <th key={header.id} colSpan={header.colSpan}>
                                  {!header.isPlaceholder && (
                                    <div>
                                      {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                      )}
                                    </div>
                                  )}
                                </th>
                              ))}
                            </tr>
                          ))}
                      </thead>
                      <tbody>
                        {props?.recentPropertyData.length > 0 ? (
                          props?.table.getRowModel().rows.map((row: any) => (
                            <tr
                              key={row.id}
                              tabIndex={0}
                              onClick={() => {
                                scrollToTop();
                                if (props.type === "agent") {
                                  navigate(`/internal/${row.original.id}`, {
                                    state: {
                                      propertyDetails: row.original,
                                      objPropertyDetails:
                                        props.objPropertyDetails
                                    }
                                  });
                                } else {
                                  NavigatePropertyDetail({
                                    propertyId: row.original?.id,
                                    propertySFID: row.original?.propertySFID,
                                    opportunitySFID:
                                      row.original?.opportunitySFID,
                                    pubPropertySFID:
                                      row.original?.pubPropertySFID,
                                    shareId: row.original?.shareKey,
                                    address: row.original?.address,
                                    bedRooms: row.original?.bedRooms,
                                    baths: row.original?.baths,
                                    sqft: row.original?.sqft,
                                    askingPrice: row.original?.askingPrice
                                  });
                                  navigate(
                                    `/external/${row.original.shareKey}`,
                                    {
                                      state: {
                                        propertyDetails: row.original,
                                        objPropertyDetails:
                                          props.objPropertyDetails
                                      }
                                    }
                                  );
                                }
                              }}
                            >
                              {row.getAllCells().map((cell: any) => (
                                <td key={cell.id}>
                                  {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                  )}
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={
                                props.table.getHeaderGroups()[0].headers.length
                              }
                            >
                              No properties available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                {props?.recentPropertyData?.length > 0 && (
                  <div className={styles.pagination}>
                    <Pagination
                      first={first}
                      rows={rows}
                      totalRecords={props.totalRecords}
                      onPageChange={onPageChange}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
      {/* {props?.recentPropertyData?.length === 0 && (
        <div className={styles.noDataContainer}>
          <NoDataFoundC panelIndex={props.panelIndex} />
        </div>
      )} */}
    </>
  );
};

export { DashboardListing };
